export const APP_CONFIG = {
  env: "divorce",
  apiPrefix: "/divorce",
  ctaColor: '#50c778',
  ctaColorPrimary: '#f6a91d',
};
